import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COMPANY_INFO, LOGO_SVG, SERVICE_LABELS } from '../constants';
import LinkedInBadge from '../icons/LinkedIn';

import LOGO_PNG from '../assets/logo.png'

function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  const onServicesPage = location.pathname.startsWith('/services');


  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <div className="footer-logo-icon">
              {/* <img src={LOGO_SVG} alt="TopFluxe Logo" /> */}
              <img src={LOGO_PNG} alt="TopFluxe Logo" />
            </div>
            <span className="footer-logo-text">{COMPANY_INFO.name}</span>
          </div>
          <p>{COMPANY_INFO.shortDescription}</p>
          <div className="social-links">
            {/* <a href={COMPANY_INFO.social.linkedin} target="_blank" rel="noopener noreferrer"></a> */}
            <LinkedInBadge />
          </div>
        </div>
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            {Object.entries(SERVICE_LABELS).map(([key, label]) => (
              onServicesPage ? (
                <li key={key}>{label}</li>
              ) : (
                <li key={key}><Link to={`/services`}>{label}</Link></li>
              )
            ))}
          </ul>
        </div>
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/work">Our Work</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li><a href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a></li>
            <li><a href={`tel:${COMPANY_INFO.phone.replace(/[^0-9+]/g, '')}`}>{COMPANY_INFO.phone}</a></li>
            <li>{COMPANY_INFO.address.city}, {COMPANY_INFO.address.state}</li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} {COMPANY_INFO.name}. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;